<template>
  <div>
    <div style="padding: 8px" ref="print" max-width="1100">
      <div
        class="p-4 ma-4"
        style="position: relative; border: 8px solid #87039f"
      >
        <div>
          <div style="position: absolute; top: 5px; left: 15px;">
            <LeftCertificateDesignsvg />
          </div>
          <div style="position: absolute; top: 5px; right: -36px;">
            <RightCertificateDesignsvg />
          </div>
          <div style="position: absolute; bottom: -79px; left: 15px;">
            <BottomLeftDesignsvg />
          </div>
          
          <div style="position: absolute; bottom: -79px; right: -36px;" >
            <BottomRightDesignsvg />
          </div>
         
          <div class="mt-12 mb-6 d-flex justify-center" style="height:44px;">
            <img src="/Certificate_IBA_Name_Image-removebg-preview.png" class="Iba-name-image"/>
          </div>
          <div class="mb-4 d-flex justify-center">
            <MindscapeLogosvg/>
          </div>
          <p
            class="Cormorant mb-4 center"
            style="color: #0753a0; font-size: 2rem;"
          >
            This certifies that
          </p>
          <v-row class="justify-center mb-1">
            <v-col md="10" class="py-0">
              <p
                class="pa-4 mb-2 center times-new-roman"
                style="font-size: 42px"
              >
              {{ GetPreviewUser.FirstName }} {{ GetPreviewUser.LastName }}
              </p>
            </v-col>
          </v-row>

          <p
            class="Cormorant center mb-2"
            style="
              color: #0753a0;
              font-size: 2rem;
              margin: auto;
            "
          >
          has completed the course of study and passed the <br/>examination to be recognized by the IBA as a
          </p>
          <v-row class="justify-center">
            <v-col md="9">
              <p
                class="pa-4 center lora"
                style="font-size: 42px"
              >
              Certified MindScape Instructor
              </p>
            </v-col>
          </v-row>

          <v-row class="mt-2 justify-center align-center">
            <v-col cols="12" md="3" style="">
              <p
                class="py-2 px-4 mb-1 dancing-script"
                style="
                  font-size: 20px;
                  border-bottom: 3px solid #0753a0;
                "
              >
              {{ userData?.Instructor }}
              </p>
              <p>Instructor</p>
            </v-col>
            <v-col cols="4" md="2" class="d-flex justify-center" style="">
              <ibaLogosvg />
            </v-col>
            <v-col cols="12" md="3" style="">
              <p
                class="py-2 px-4 mb-1 times-new-roman"
                style="
                  font-size: 18px;
                  border-bottom: 3px solid #0753a0;
                "
              >
              <!-- {{userData?.DateGraduated?.split("T")[0] }} -->
              {{ formatDate(userData?.DateGraduated) }}
              </p>
              <p>Date</p>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ibaLogosvg from "../../../assets/SvgIcons/ibaLogosvg.vue";
import MindscapeLogosvg from "../../../assets/SvgIcons/MindscapeLogosvg.vue";
import BottomLeftDesignsvg from "../../../assets/SvgIcons/bottomLeftDesignsvg.vue";
import BottomRightDesignsvg from "../../../assets/SvgIcons/bottomRightDesignsvg.vue";
import LeftCertificateDesignsvg from "../../../assets/SvgIcons/leftCetificateDesignsvg.vue";
import RightCertificateDesignsvg from "../../../assets/SvgIcons/rightCertificateDesignsvg.vue";
export default {
  name: "MSICertificate",
  computed: {
    ...mapGetters([
      "GetPreviewUser"
    ]),
  },
  props:["userData"],
  components: {
    ibaLogosvg,
    MindscapeLogosvg,
    LeftCertificateDesignsvg,
    RightCertificateDesignsvg,
    BottomLeftDesignsvg,
    BottomRightDesignsvg,
  },
  data() {
    return {};
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(date).toLocaleDateString(undefined, options);
    },
  },
};
</script>
<!-- @import url('https://fonts.cdnfonts.com/css/times-new-roman'); -->
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Great+Vibes&family=Jacquard+24&family=Pacifico&family=Parisienne&family=UnifrakturCook:wght@700&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Dancing+Script:wght@400..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lora:wght@400;700&display=swap');
@import url("https://fonts.googleapis.com/css2?family=Cormorant+Upright:wght@300;400;500;600;700&family=Sedan:ital@0;1&display=swap");
.times-new-roman {
  font-family: 'Times New Roman', sans-serif;
}
.lora {
  font-family: "Lora", serif;
  font-weight: 500;
  font-style: normal;
}
.Cormorant {
  font-family: "Cormorant Upright", serif;
  font-weight: 700;
  letter-spacing: 1px;
  font-style: normal;
}
.Edwardian {
  font-family: "Great Vibes", cursive;
  font-style: normal;
  letter-spacing: 1px;
}
.dancing-script {
  font-family: "Cedarville Cursive", cursive;
  font-weight: 400;
  font-style: normal;
}
.certificate-title {
  font-family: "Jacquard 24", system-ui;
  font-style: normal;
}
.center {
  text-align: center;
}
.Iba-name-image{
  width:70%; margin:auto; height:33px; object-fit:contain
}
@media(min-width:1024px){
  .Iba-name-image{
    height:36px;
  }
}
@media(min-width:1200px){
  .Iba-name-image{
    height:44px;
  }
}
</style>
